export enum CardVariantsEnum {
  'dark-primary' = 'dark-primary',
  'dark-secondary' = 'dark-secondary',
  white = 'white',
}

export type MktCardVariant = `${CardVariantsEnum}`;
